// extracted by mini-css-extract-plugin
export default {"updateUserCard":"update_updateUserCard__bQheN","buttons":"update_buttons__Uw3-e","updateBtn":"update_updateBtn__fCKwi","cancelBtn":"update_cancelBtn__gN-5p"};